/* Crossfade: storefront-only inactivity policy. Does not reserve stock or cancel checkout. */
(function () {
  'use strict';
  const TIMEOUT = 30 * 60 * 1000;
  const KEY = 'crossfade.cart-inactivity.v1';
  const LOCK = 'crossfade.cart-inactivity.v1';
  function decision(state, cart, now) {
    if (!state || state.version !== 1 || typeof state.at !== 'number' || !Number.isFinite(state.at)) return 'baseline';
    if (state.id !== cart.id || state.fp !== cart.fp) return 'changed';
    if (state.checkout) return 'checkout';
    if (Array.isArray(state.pending) && state.pending.length) return 'mutation';
    if (!cart.count) return 'empty';
    if (state.at > now || now - state.at < TIMEOUT) return 'active';
    return 'expired';
  }
  function checkoutElement(path) {
    return path.some(function (el) {
      if (!el || typeof el.matches !== 'function') return false;
      if (el.matches('[name="checkout"], .shopify-payment-button, .shopify-payment-button__button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify="payment-button"], [data-testid="ShopifyPay-button"]')) return true;
      const href = el.getAttribute && el.getAttribute('href');
      const action = el.getAttribute && el.getAttribute('action');
      return [href, action].some(function (url) { return url && /(?:\/checkouts?(?:\/|\?|$)|shop\.app\/|shopify\.com\/.*checkout)/i.test(url); });
    });
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { decision, checkoutElement, TIMEOUT }; return; }
  if (window.__crossfadeCartExpiry) return;
  window.__crossfadeCartExpiry = true;
  // This module intentionally does not run on checkout/account pages.
  if (/\/(?:checkouts?|account)(?:\/|$)/i.test(location.pathname)) return;
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  if (!root || !root.startsWith('/') || root.startsWith('//')) return;
  let messages;
  try { messages = JSON.parse(document.getElementById('crossfade-cart-policy-config').textContent); } catch (_) { return; }
  if (!['reservation', 'timeout', 'checkout', 'keep', 'cleared', 'expiring'].every(key => typeof messages[key] === 'string' && messages[key])) return;
  let mutations = 0;
  let supported = !!(window.crypto && crypto.subtle && typeof crypto.randomUUID === 'function' && navigator.locks && navigator.locks.request);
  let stopped = false, busy = false, ready = false, interacted = false, checkoutIntent = false, lastTouch = 0;
  let current = null, pending = false;
  try { localStorage.setItem(KEY + '.probe', '1'); localStorage.removeItem(KEY + '.probe'); } catch (_) { supported = false; }
  const read = function () { try { const raw = localStorage.getItem(KEY); const value = raw ? JSON.parse(raw) : null; return value && typeof value === 'object' && !Array.isArray(value) ? value : null; } catch (_) { stopped = true; return null; } };
  const write = function (value) { try { localStorage.setItem(KEY, JSON.stringify(value)); return true; } catch (_) { stopped = true; return false; } };
  const hash = async function (value) { const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)); return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join(''); };
  async function getCart() {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    if (!cart || typeof cart.token !== 'string' || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count)) throw new Error('Unexpected cart');
    return { id: await hash(cart.token), fp: await hash(JSON.stringify(cart.items.map(item => [item.key, item.quantity]).sort((a,b) => String(a[0]).localeCompare(String(b[0]))))), count: cart.item_count };
  }
  function baseline(cart, preserveCheckout) { return { version: 1, id: cart.id, fp: cart.fp, at: Date.now(), checkout: !!(checkoutIntent || preserveCheckout) }; }
  function touch(event) {
    if (event && !event.isTrusted) return;
    interacted = true;
    if (!supported || stopped || !ready) return;
    const now = Date.now();
    if (now - lastTouch < 1000) return;
    lastTouch = now;
    const state = read();
    if (state && current && state.id === current.id) { state.at = now; write(state); }
    renderNotices();
  }
  function guardCheckout(event) {
    const path = event.composedPath ? event.composedPath() : [event.target];
    if (!checkoutElement(path) && !(event.submitter && checkoutElement([event.submitter]))) return;
    checkoutIntent = true;
    const state = read();
    if (state) { state.checkout = true; state.at = Date.now(); write(state); }
    renderNotices();
  }
  // Capture before theme handlers/navigation; pointerdown covers closed shadow accelerated controls.
  ['pointerdown', 'click', 'focusin', 'submit'].forEach(type => document.addEventListener(type, guardCheckout, true));
  ['pointerdown', 'keydown', 'input', 'change', 'scroll'].forEach(type => document.addEventListener(type, touch, { capture: true, passive: true }));
  try { if (/\/checkouts?(?:\/|\?|$)/i.test(new URL(document.referrer).pathname)) checkoutIntent = true; } catch (_) { /* empty referrer */ }
  function warningText() {
    if (!supported || stopped) return messages.reservation;
    const state = read();
    if (checkoutIntent || (state && state.checkout)) return messages.checkout;
    return messages.timeout;
  }
  function renderNotices() {
    document.querySelectorAll('[data-crossfade-cart-policy]').forEach(function (container) {
      let text = container.querySelector('[data-crossfade-cart-policy-text]');
      if (!text) { text = document.createElement('p'); text.dataset.crossfadeCartPolicyText = ''; container.appendChild(text); }
      const next = warningText();
      if (text.textContent !== next) text.textContent = next;
      let keep = container.querySelector('button');
      const state = supported && !stopped ? read() : null;
      const show = !!(state && !state.checkout && !(state.pending && state.pending.length) && Date.now() - state.at >= TIMEOUT - 120000);
      let countdown = container.querySelector('[data-crossfade-cart-expiring]');
      if (show && !countdown) { countdown = document.createElement('p'); countdown.dataset.crossfadeCartExpiring = ''; countdown.setAttribute('role', 'status'); countdown.setAttribute('aria-live', 'polite'); container.appendChild(countdown); }
      if (countdown) { countdown.hidden = !show; countdown.style.display = show ? '' : 'none'; const content = show ? messages.expiring : ''; if (countdown.textContent !== content) countdown.textContent = content; }
      if (show && !keep) { keep = document.createElement('button'); keep.type = 'button'; keep.textContent = messages.keep; keep.className = 'button button--secondary'; keep.addEventListener('click', touch); container.appendChild(keep); }
      if (keep) { const retain = supported && !stopped && state && !state.checkout; keep.hidden = !retain; keep.style.display = retain ? '' : 'none'; }
    });
  }
  // Theme integrations place these lightweight containers by the cart summary and drawer checkout.
  const observer = new MutationObserver(function () { if (!pending) { pending = true; queueMicrotask(function () { pending = false; renderNotices(); }); } });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  function announceClear() {
    try { sessionStorage.setItem('crossfade.cart-cleared.v1', '1'); } catch (_) { /* no notification persistence */ }
    // Reload only after verified clear: ensures native cart page/drawer/badge stay consistent.
    location.reload();
  }
  async function check() {
    if (!supported || stopped || busy || mutations || document.visibilityState === 'hidden') return;
    busy = true;
    try {
      await navigator.locks.request(LOCK, { ifAvailable: true }, async function (lock) {
        if (!lock || stopped) return;
        let state = read();
        if (ready && state && (state.checkout || checkoutIntent || (Array.isArray(state.pending) && state.pending.length) || Date.now() - state.at < TIMEOUT)) { renderNotices(); return; }
        const cart = await getCart(); current = cart;
        if (stopped) return;
        state = read();
        const result = decision(state, cart, Date.now());
        if (mutations || (state && Array.isArray(state.pending) && state.pending.length)) return;
        if (checkoutIntent || (state && state.id === cart.id && state.checkout)) {
          write(baseline(cart, true)); ready = true; renderNotices(); return;
        }
        if (result !== 'expired' || (!ready && interacted)) {
          if (result === 'baseline' || result === 'changed' || result === 'empty' || (!ready && interacted)) write(baseline(cart, false));
          ready = true; renderNotices(); return;
        }
        // Fresh fingerprint + shared state check after a second read; no blind clearing of a changed cart.
        const expected = JSON.stringify(state);
        const verify = await getCart();
        if (stopped || mutations || checkoutIntent || JSON.stringify(read()) !== expected || decision(state, verify, Date.now()) !== 'expired') return;
        if (document.visibilityState === 'hidden') return;
        const response = await fetch(root + 'cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: '{}' });
        if (!response.ok) throw new Error('Cart clear unavailable');
        const empty = await response.json();
        if (empty.item_count !== 0 || !Array.isArray(empty.items) || empty.items.length) throw new Error('Cart clear unconfirmed');
        // A final fresh read prevents a false-cleared message if a concurrent add succeeded afterward.
        const after = await getCart();
        write(baseline(after, false));
        if (!after.count) announceClear();
      });
    } catch (_) { /* Fail safe: no retry storm, no false cleared claim. Next scheduled check may retry reads. */ }
    finally { busy = false; ready = true; renderNotices(); }
  }
  // Shopify standard cart events carry a promise for the in-flight mutation.
  ['shopify:cart:lines-update', 'shopify:cart:note-update', 'shopify:cart:discount-update'].forEach(type => document.addEventListener(type, function (event) {
    touch();
    if (!supported || stopped) return;
    mutations++;
    const marker = crypto.randomUUID();
    const state = read();
    if (state) { state.pending = [...(state.pending || []), marker]; write(state); }
    if (!event.promise || typeof event.promise.then !== 'function') { stopped = true; renderNotices(); return; }
    Promise.resolve(event.promise).catch(function () { /* Failed cart edits still count as activity. */ }).finally(function () {
      mutations--;
      const latest = read();
      if (latest) { latest.pending = (latest.pending || []).filter(value => value !== marker); latest.at = Date.now(); write(latest); }
      ready = false; check();
    });
  }));
  window.addEventListener('storage', function (event) { if (event.key === KEY) renderNotices(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') check(); });
  window.addEventListener('pageshow', check);
  try {
    if (sessionStorage.getItem('crossfade.cart-cleared.v1') === '1') {
      sessionStorage.removeItem('crossfade.cart-cleared.v1');
      const notice = document.createElement('div'); notice.setAttribute('role', 'status'); notice.className = 'crossfade-cart-cleared';
      notice.textContent = messages.cleared;
      const main = document.querySelector('main'); if (main) main.prepend(notice);
    }
  } catch (_) { /* optional message */ }
  renderNotices(); check(); setInterval(check, 15000);
})();
